import * as PIXI from "pixi.js";
import Main from "../../../Main";
import HTPFirstPart from "../HTPFirstPart";


export default class ClickAnyWhereText extends PIXI.Container {
  private Main = Main.getInstance()
  private HTPFirstPart = HTPFirstPart.getInstance();
  startScale=.1;
  constructor() {
    super();
    this.addCoord();
    this.addBg();
    this.addText();
    this.addToCon();

    this.visible = false;
  }

  addCoord() {
    const dim = this.Main.getDim();
    this.x = dim.width / 2;
    this.y = dim.height / 2 + 250;
    this.scale.set(this.startScale);
  }

  addText() {
    const text = new PIXI.Text({ text: "CLICK ANYWHERE TO CONTINUE" })
    text.style = {
      fontSize: 25,
      fill: 0xFFFFFF
    }
    text.anchor.set(.5);
    text.x = 0;
    text.y = 0;
    this.addChild(text);
  }
  addBg() {
    const bg = new PIXI.Graphics()
      .roundRect(-250, -25, 500, 50, 15)
      .fill(0x11341f);

    this.addChild(bg);
  }
  addToCon() {
    this.HTPFirstPart.addChild(this);
  }
}